var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container"},[_c('ClipLoader',{class:'custom-class',attrs:{"loading":true,"color":'#3F69D2',"size":50,"sizeUnit":'px'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }